var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useDispatch } from "react-redux";
import { CountryEditBlocks } from "./countryEditBlocks";
import RegBlock from './regblock';
import BeckonBlock from './beckonBlock';
import MoreContainer from './modules/morecontainer';
// import MoreContainer from './modules/moreContainer'
export var unRegBlocks = [
    'beckonblock',
    'countryratinglinks',
    'prefixgenerator',
    'coatofarmsgenerator',
    'passport',
    'readmore',
];
export var listTypeBlocks = [
    'leaguelist',
    'magistrature',
    'orderlist',
    'geozone',
];
export var SpecBlocks = function (props) {
    var dragHandleProps = props.dragHandleProps, isDragging = props.isDragging, colorStyle = props.colorStyle, isEditable = props.isEditable, post = props.post, _a = props.specBlockProps, specBlockProps = _a === void 0 ? {} : _a;
    var type = post.specBlock.type;
    var blockType = post.specBlock.type;
    var blockEls = post.specBlock.blockElements;
    // console.log('SpecBlocks', props);
    return React.createElement(React.Fragment, null,
        blockType === 'beckonblock'
            ? React.createElement(BeckonBlock, { dragHandleProps: dragHandleProps, blockEls: blockEls, type: post.specBlock.type, isDragging: isDragging, colorStyle: colorStyle, isEditable: isEditable, post: post })
            : undefined,
        blockType === 'countryratinglinks'
            ? React.createElement(BeckonBlock, { dragHandleProps: dragHandleProps, blockEls: blockEls, type: post.specBlock.type, isDragging: isDragging, colorStyle: colorStyle, isEditable: isEditable, post: post })
            : undefined,
        ['prefixgenerator', 'coatofarmsgenerator', 'passport'].includes(blockType)
            ? React.createElement(CountryEditBlocks, { dragHandleProps: dragHandleProps, blockEls: blockEls, type: post.specBlock.type, isDragging: isDragging, colorStyle: colorStyle, isEditable: isEditable, post: post, specBlockProps: __assign({ externalArea: { area: {} }, externalCountry: { country: {} }, externalCommon: null, externalCountryEditData: null, paramCountryId: '', paramId: null, isArea: false, profile: null, t: null, i18n: null, breakPoint: null, history: null, isModerOwner: null, countryName: null, countryPrefix: null, changesByNotOwner: null }, specBlockProps) })
            : undefined,
        ['readmore'].includes(blockType)
            ? React.createElement(MoreContainer, __assign({ specBlockProps: specBlockProps }, props))
            : undefined,
        blockType === 'regularblock' || !unRegBlocks.includes(blockType)
            ? React.createElement(RegBlock, __assign({ dragHandleProps: dragHandleProps, blockEls: blockEls, type: blockType, isDragging: isDragging, colorStyle: colorStyle, isEditable: isEditable }, props))
            : undefined);
};
//# sourceMappingURL=index.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useDispatch } from "react-redux";
import { CountryEditBlocks } from "./countryEditBlocks";
import RegBlock from './regblock';
import BeckonBlock from './beckonBlock';
import MoreContainer from './modules/morecontainer';
// import MoreContainer from './modules/moreContainer'
export var unRegBlocks = [
    'beckonblock',
    'countryratinglinks',
    'prefixgenerator',
    'coatofarmsgenerator',
    'passport',
    'readmore',
];
export var listTypeBlocks = [
    'leaguelist',
    'magistrature',
    'orderlist',
    'geozone',
];
export var SpecBlocks = function (props) {
    var dragHandleProps = props.dragHandleProps, isDragging = props.isDragging, colorStyle = props.colorStyle, isEditable = props.isEditable, post = props.post, _a = props.specBlockProps, specBlockProps = _a === void 0 ? {} : _a;
    var type = post.specBlock.type;
    var blockType = post.specBlock.type;
    var blockEls = post.specBlock.blockElements;
    // console.log('SpecBlocks', props);
    return React.createElement(React.Fragment, null,
        blockType === 'beckonblock'
            ? React.createElement(BeckonBlock, { dragHandleProps: dragHandleProps, blockEls: blockEls, type: post.specBlock.type, isDragging: isDragging, colorStyle: colorStyle, isEditable: isEditable, post: post })
            : undefined,
        blockType === 'countryratinglinks'
            ? React.createElement(BeckonBlock, { dragHandleProps: dragHandleProps, blockEls: blockEls, type: post.specBlock.type, isDragging: isDragging, colorStyle: colorStyle, isEditable: isEditable, post: post })
            : undefined,
        ['prefixgenerator', 'coatofarmsgenerator', 'passport'].includes(blockType)
            ? React.createElement(CountryEditBlocks, { dragHandleProps: dragHandleProps, blockEls: blockEls, type: post.specBlock.type, isDragging: isDragging, colorStyle: colorStyle, isEditable: isEditable, post: post, specBlockProps: __assign({ externalArea: { area: {} }, externalCountry: { country: {} }, externalCommon: null, externalCountryEditData: null, paramCountryId: '', paramId: null, isArea: false, profile: null, t: null, i18n: null, breakPoint: null, history: null, isModerOwner: null, countryName: null, countryPrefix: null, changesByNotOwner: null }, specBlockProps) })
            : undefined,
        ['readmore'].includes(blockType)
            ? React.createElement(MoreContainer, __assign({ specBlockProps: specBlockProps }, props))
            : undefined,
        blockType === 'regularblock' || !unRegBlocks.includes(blockType)
            ? React.createElement(RegBlock, __assign({ dragHandleProps: dragHandleProps, blockEls: blockEls, type: blockType, isDragging: isDragging, colorStyle: colorStyle, isEditable: isEditable }, props))
            : undefined);
};
//# sourceMappingURL=index.js.map